
import { Component, Vue } from "vue-property-decorator";
import GlobalConfig from "@/GlobalConfig";

@Component({})
export default class TipoEnvioEstadoCuentaResult extends Vue {
    public email: string = this.$store.state.user.correoElectronico1;
    public nombre: string = `${this.$store.state.user.primerNombre} ${this.$store.state.user.primerApellido}`;
    public userId: string = this.$store.state.user.cedula;

    public async mounted() {
    }

    returnHome() {
        window.location.href = GlobalConfig.PORTAL_BASE_URL
    }
	updateUser() {
        this.$router.push("actualizacion-de-datos");
    }
}
